import { render } from "./ReportNewRegistars.vue?vue&type=template&id=7262f89e&ts=true"
import script from "./ReportNewRegistars.vue?vue&type=script&lang=ts"
export * from "./ReportNewRegistars.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__